module.exports = __webpack_public_path__ + "static/media/TA.735b74d6.svg";